<div class="approval_card">
    <div class="approval_title">
        <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.RULES' | transloco }}</h4>
        <button
            class="mat-tooltip-trigger btn primary-ebtn"
            [disabled]="addDisabled()"
            (click)="addnewRule()"
            *ngIf="iscreateRule"
            matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.ADD_NEW_RULE' | transloco }}"
            [matTooltipPosition]="tooltip_position"
        >
            <i class="fa fa-plus"></i>
        </button>
    </div>

    <div class="approval_card_section">
        <div class="approval_list" *ngIf="rules?.length > 0">
            <ul>
                <li *ngFor="let item of rules" [class.visited]="item.approvalRuleId == selectedRule?.approvalRuleId" (click)="selectedItem(item)">
                    <div class="row align-items-center">
                        <div class="col-8">
                            <div class="d-flex align-items-center">
                                {{ item.name }}
                            </div>
                        </div>

                        <!-- <div class="col-6">
                            <div class="d-flex justify-content-center">
                                <p-selectButton [options]="stateOptions" [(ngModel)]="item.enabled" optionLabel="label"
                                    optionValue="value" (click)="toggleSwitch($event,item.enabled,item)">
                                </p-selectButton>
                            </div>
                        </div> -->
                        <div class="col-4">
                            <div class="social_icon text-center">
                                <mat-icon>
                                    <a
                                        href="javascript:void(0)"
                                        *ngIf="iseditRule"
                                        href="javascript:void(0)"
                                        #tooltip="matTooltip"
                                        matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.EDIT' | transloco }}"
                                        [matTooltipPosition]="tooltip_position"
                                        (click)="editRule(item, $event)"
                                        >edit</a
                                    >
                                </mat-icon>

                                <a
                                    href="javascript:void(0)"
                                    #tooltip="matTooltip"
                                    matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.DELETE' | transloco }}"
                                    [matTooltipPosition]="tooltip_position"
                                    *ngIf="isDeleteRolevisible"
                                >
                                    <i class="flaticon2-cross" (click)="deleteRule(item, $event)"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="code_details_inside card_text_center" *ngIf="rules?.length == 0">
            <div class="configure-wrap">
                <h3>{{ 'SETTING_PAGE.IDMS_SETTINGS.ADD_RULE_TO_CONFIGURE' | transloco }}</h3>
            </div>
        </div>
    </div>
</div>
